// Copyright 2025, University of Maryland, All Rights Reserved
import { axiosInstance, handleApiError } from './client'

export interface SetJobResponse {
  job_id: string
  status: string
  message: string
}

export interface SetProcessResponse {
  is_structured: false
  raw_response: string
  filenames: string[]
  file_count: number
  prompt_name: string
  prompt_type: string
  analysis_type: string
  llm_model: string
  llm_cost: number
  analysis_timestamp: string
  content_characters: number
}

export const setApi = {
  async processFiles(
    files: File[],
    prompt_name: string,
    prompt_type: string,
    org_id: string,
    ws_id: string,
    user_id: string
  ): Promise<SetJobResponse> {
    const formData = new FormData()
    files.forEach(f => formData.append('files', f))
    formData.append('prompt_name', prompt_name)
    formData.append('prompt_type', prompt_type)

    try {
      // Do NOT set Content-Type manually — axios sets it automatically with the
      // correct multipart boundary when it detects a FormData body.
      const response = await axiosInstance.post('/analysis/set/process', formData, {
        params: { org_id, ws_id, user_id },
      })
      return response.data
    } catch (error) {
      throw handleApiError(error)
    }
  },

  async fetchResult(
    job_id: string,
    org_id: string,
    ws_id: string
  ): Promise<SetProcessResponse> {
    try {
      const response = await axiosInstance.get(`/analysis/set/result/${job_id}`, {
        params: { org_id, ws_id },
      })
      return response.data
    } catch (error) {
      throw handleApiError(error)
    }
  },

}
